"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialRatePlanResponseToJSON = exports.InitialRatePlanResponseFromJSONTyped = exports.InitialRatePlanResponseFromJSON = void 0;
function InitialRatePlanResponseFromJSON(json) {
    return InitialRatePlanResponseFromJSONTyped(json, false);
}
exports.InitialRatePlanResponseFromJSON = InitialRatePlanResponseFromJSON;
function InitialRatePlanResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...json,
        'ratePlanId': json['ratePlanId'],
    };
}
exports.InitialRatePlanResponseFromJSONTyped = InitialRatePlanResponseFromJSONTyped;
function InitialRatePlanResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...value,
        'ratePlanId': value.ratePlanId,
    };
}
exports.InitialRatePlanResponseToJSON = InitialRatePlanResponseToJSON;
//# sourceMappingURL=InitialRatePlanResponse.js.map